// FOUND-09: Versioned rates snapshot for 2026.
// Phase 4 [VERIFY-2026] — all values re-confirmed 2026-04-30.
// IMPORTANT: Do not surface verifiedAt fields in UI — they are source-tracking metadata only.

export const rates2026 = {
  meta: { jahr: 2026 as const, gueltigAb: "2026-01-01" as const },

  strom: {
    haushaltsstrompreis_ct_kwh: {
      value: 37.0,
      verifiedAt: "2026-04-30",
      source: "BDEW Strompreisanalyse 2026",
    },
    einspeiseverguetung_ct_kwh: {
      // Alias for strom-level entry; canonical value lives in eeg2026.teileinspeisung.bis10kwp.
      value: 7.78,
      verifiedAt: "2026-04-30",
      source: "EEG 2023 §48, finanztip.de 2026-04-30",
    },
    co2_faktor_kg_kwh: {
      value: 0.380,
      verifiedAt: "2026-04-30",
      source: "Umweltbundesamt Emissionsfaktoren",
    },
  },

  eeg2026: {
    teileinspeisung: {
      bis10kwp: {
        value: 7.78,
        verifiedAt: "2026-04-30",
        source: "EEG 2023 §48, finanztip.de 2026-04-30",
      },
      kwp10bis40: {
        value: 6.73,
        verifiedAt: "2026-04-30",
        source: "EEG 2023 §48",
      },
      kwp40bis100: {
        value: 5.50,
        verifiedAt: "2026-04-30",
        source: "EEG 2023 §48",
      },
    },
    volleinspeisung: {
      bis10kwp: {
        value: 12.34,
        verifiedAt: "2026-04-30",
        source: "EEG 2023 §48",
      },
      kwp10bis40: {
        value: 10.35,
        verifiedAt: "2026-04-30",
        source: "EEG 2023 §48",
      },
      kwp40bis100: {
        value: 10.35,
        verifiedAt: "2026-04-30",
        source: "EEG 2023 §48",
      },
    },
  },

  // KfW 261 — Bundesförderung für effiziente Gebäude (Wohngebäude-Kredit)
  // Tilgungszuschuss-Sätze verified 2026-04-30 via kfw.de
  // Zinssatz ist marktabhängig und ändert sich wöchentlich — nicht hier abgebildet.
  kfw261: {
    zinssatzHinweis: "Aktueller Zinssatz unter https://www.kfw.de/Programme/Energie-Klimaschutz/BEG-Wohngebaeude-Kredit-261/ abrufbar. Zinssatz ist marktabhängig und ändert sich wöchentlich.",
    maxDarlehen: {
      value: 150000,
      verifiedAt: "2026-05-04",
      source: "KfW Merkblatt 261 §5 Abs. 1 — Kreditbetrag max. 150.000 € je Wohneinheit, gültig ab 01.04.2024",
    },
    tilgungszuschuss: {
      eh40: {
        value: 0.20,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      eh40EeKlasse: {
        value: 0.25,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      eh55: {
        value: 0.15,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      eh55EeKlasse: {
        value: 0.20,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      eh70: {
        value: 0.10,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      eh70EeKlasse: {
        value: 0.15,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      eh85: {
        value: 0.05,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      eh85EeKlasse: {
        value: 0.10,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
      denkmal: {
        value: 0.05,
        verifiedAt: "2026-04-30",
        source: "kfw.de 2026-04-30",
      },
    },
    // iSFP-Bonus: nicht mehr auf kfw.de sichtbar per 2026-04-30.
    // Der Bonus existierte historisch als +5 Prozentpunkte bei vorliegendem iSFP.
    // ACHTUNG: Bis zur Bestätigung durch den Nutzer nicht in Berechnungen einbeziehen.
    isfpBonus: {
      value: 0.05,
      verifiedAt: "iSFP-not-visible-2026-04-30",
      source: "kfw.de 2026-04-30 — Bonus nicht mehr sichtbar; historischer Wert",
    },
  },

  // KfW 458 — Bundesförderung für effiziente Gebäude (Heizungsförderung)
  kfw458: {
    grundfoerdersatz: {
      value: 0.30,
      verifiedAt: "2026-04-30",
      source: "kfw.de 2026-04-30",
    },
    klimageschwindigkeitsbonus: {
      value: 0.20,
      gueltigBis: "2028-12-31",
      verifiedAt: "2026-04-30",
      source: "kfw.de 2026-04-30",
    },
    einkommensbonus: {
      value: 0.30,
      einkommensgrenze: 40000,
      verifiedAt: "2026-04-30",
      source: "kfw.de 2026-04-30",
    },
    effizienzbonus: {
      value: 0.05,
      verifiedAt: "2026-04-30",
      source: "kfw.de 2026-04-30",
    },
    maxFoerdersatz: {
      value: 0.70,
      verifiedAt: "2026-04-30",
      source: "kfw.de 2026-04-30",
    },
    maxFoerderfaehigeKostenEfh: {
      value: 30000,
      verifiedAt: "2026-04-30",
      source: "kfw.de 2026-04-30",
    },
  },

  // BAFA BEG-Einzelmaßnahmen
  // Kostencaps: Quellseite bafa.de war zum Verifizierungszeitpunkt nicht erreichbar.
  // Werte mit "TBD-USER-CONFIRM" müssen durch Nutzer bestätigt werden.
  bafaEm: {
    grundfoerdersatz: {
      value: 0.15,
      verifiedAt: "2026-04-30",
      source: "finanztip.de 2026-04-30",
    },
    isfpBonus: {
      value: 0.05,
      verifiedAt: "2026-04-30",
      source: "finanztip.de 2026-04-30",
    },
    maxFoerdersatz: {
      value: 0.20,
      verifiedAt: "2026-04-30",
      source: "finanztip.de 2026-04-30",
    },
    maxFoerderfaehigeKostenEfhOhneIsfp: {
      value: 30000,
      verifiedAt: "2026-05-04",
      source: "BAFA BEG EM Merkblatt §6 Abs. 3 — gültig ab 01.01.2024",
    },
    maxFoerderfaehigeKostenEfhMitIsfp: {
      value: 60000,
      verifiedAt: "2026-05-04",
      source: "BAFA BEG EM Merkblatt §6 Abs. 3 (mit iSFP-Bonus) — gültig ab 01.01.2024",
    },
  },
} as const;

export type Rates2026 = typeof rates2026;
